import { environment } from '@hb/hypotheken-berekening.environment';

import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

import { ApContentModule } from '@ap/content';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonComponent, ApSubmitTextComponent } from '@ap/button';

@Component({
    selector: 'next-button',
    templateUrl: './next-button.component.html',
    standalone: true,
    imports: [ApContentModule, ApAnalyticsModule, ApButtonComponent, ApSubmitTextComponent, NgClass]
})
export class NextButtonComponent {
    protected readonly environment = environment;

    @Input() isLoading = false;
    @Input() contentKey = 'general.question.next';
}
